/** Shared state/event contract between the update owner and sidebar presenter. */
export const APP_UPDATE_STATE_EVENT = 'app-update:state-change';
export const APP_UPDATE_APPLY_EVENT = 'app-update:apply';

export type AppUpdateStateDetail = {
  available: boolean;
  version?: string;
  build?: string;
  builtAt?: string;
};

let latestAppUpdateState: AppUpdateStateDetail = { available: false };

/** Hydrates presenters that mount after the latest update-state event. */
export function getLatestAppUpdateState(): AppUpdateStateDetail {
  return latestAppUpdateState;
}

export function publishAppUpdateState(detail: AppUpdateStateDetail): void {
  latestAppUpdateState = detail;
  window.dispatchEvent(new CustomEvent<AppUpdateStateDetail>(APP_UPDATE_STATE_EVENT, { detail }));
}
